import axios from 'axios'
import indexedDB from '@/services/IndexedDBService'
import lsService from '@/services/LocalStorageService'
import dateService from '@/services/DateService'
import noteMeta from '@/services/NoteMeta'
import noteHistoryService from '@/services/NoteHistoryService'

// TODO: 外だしする
const SERVICE = 'harvester'
const API_KEY = 'eFNrWgpH8PU8gNTUYpJA7FO6CBwcwue7hI2cNaIf'
// const SESSION_ID_KEY = 'EG_SESSION_ID' // to_be_removed
const TEMPORAY_TOKEN_KEY = 'EG_TEMPORARY_TOKEN'
const API_URLS = {
  development: 'https://feature-api.harvester.lakesoft.jp',
  // 'https://s0u6y4d4j9.execute-api.ap-northeast-1.amazonaws.com/dev',
  production: 'https://api.harvester.lakesoft.jp'
  //'https://pts09lkxh0.execute-api.ap-northeast-1.amazonaws.com/prod'
}
const API_GATEWAY_HOST = 'a2xfkt1lk7.execute-api.ap-northeast-1.amazonaws.com'

const LOGGED_IN_BEFORE_KEY = 'EG_LOGGED_IN_BEFORE'

//<---

// EVERNOTE SECRET CONSTANTS
const EVERNOTE_API_LIMIT_COUNT = 150

// CONSTANTS
const MAX_RELATED_NOTES = 10
const MAX_NOTES = 15

// local storage
const EG_SELECTED_NOTEBOOK_GUID_KEY = 'EG_SELECTED_NOTEBOOK_GUID'
const EG_RECENT_NOTEBOOK_GUIDS_KEY = 'EG_RECENT_NOTEBOOK_GUIDS'
const EG_RECENT_NOTEBOOKS_MAX = 10
const EG_DEFAULT_NOTEBOOK_GUID_KEY = 'EG_DEFAULT_NOTEBOOK_GUID'

const EG_SELECTED_TAG_GUIDS_KEY = 'EG_SELECTED_TAG_GUIDS_KEY'
const EG_RECENT_TAG_GUIDS_KEY = 'EG_RECENT_TAG_GUIDS'
const EG_RECENT_TAGS_MAX = 10

const EG_USER_KEY = 'EG_USER_KEY'
const EG_API_COUNTER_KEY = 'EG_API_COUNTER'

class EvernoteService {
  constructor() {
    // INFO: 環境変数から取得できず→手動で切り替え
    // this.api_env = 'prod'
    // TODO: 外だしする
    this.api_env = process.env.VUE_APP_ENV || 'production'
    console.log(`env: ${process.env.VUE_APP_ENV}`)
    this._notebooks = undefined
    this._tags = undefined
    this._token = undefined

    this.isLoggedIn = true

    this.maxNotes = MAX_NOTES

    this.events = {}

    //-------------
    // reminder
    //-------------
    // query name 'rc'
    this.reminderConditions = [
      {
        value: '10',
        label: 'すべてのリマインダ',
        words: 'reminderOrder:*',
        color: 'grey'
      },
      {
        value: '20',
        label: '日付の無いリマインダ',
        words: 'reminderOrder:* -reminderTime:* -reminderDoneTime:*',
        color: 'purple'
      },
      {
        value: '30',
        label: '未完了のリマインダ',
        words: 'reminderOrder:* -reminderDoneTime:*',
        color: 'pink lighten-2'
      },
      {
        value: '40',
        label: '期限切れのリマインダ',
        words: 'reminderTime:year-100 -reminderTime:day -reminderDoneTime:*',
        color: 'red'
      },
      {
        value: '50',
        label: '今日以降のリマインダ',
        words: 'reminderTime:day -reminderDoneTime:*',
        color: 'blue'
      },
      {
        value: '90',
        label: '済んだリマインダ',
        words: 'reminderDoneTime:*',
        color: 'green'
      }
    ]
    // this.reminderSorts = [
    //   { value: '1', label: 'リマインダ日付昇順' },
    //   { value: '2', label: 'リマインダ日付降順' }
    // ]
    //-------------
    // date
    //-------------
    // query name 'rc'
    this.dateConditions = [
      {
        value: 'd1',
        label: '本日',
        words: 'created:day'
      },
      {
        value: 'd2',
        label: '昨日',
        words: 'created:day-1 -created:day'
      },
      {
        value: 'd3',
        label: '過去3日',
        words: 'created:day-3 -created:day'
      },
      {
        value: 'w1',
        label: '今週',
        words: 'created:week'
      },
      {
        value: 'w2',
        label: '先週',
        words: 'created:week-1 -created:week'
      },
      {
        value: 'd7',
        label: '過去7日',
        words: 'created:day-7 -created:day'
      },
      {
        value: 'm1',
        label: '今月',
        words: 'created:month'
      },
      {
        value: 'm2',
        label: '先月',
        words: 'created:month-1 -created:month'
      },
      {
        value: 'd30',
        label: '過去30日',
        words: 'created:day-30 -created:day'
      },
      {
        value: 'd90',
        label: '過去90日',
        words: 'created:day-90 -created:day'
      },
      {
        value: 'y1',
        label: '今年',
        words: 'created:year'
      },
      {
        value: 'y2',
        label: '昨年',
        words: 'created:year-1 -created:year'
      }
    ]
    this.yearMonthConditions = []
    this.yearConditions = []

    //-------------
    // file
    //-------------
    // query name 'rc'
    this.fileConditions = [
      {
        value: 'f1',
        label: 'PDFあり',
        words: 'resource:application/pdf'
      },
      {
        value: 'f2',
        label: '画像あり',
        words: 'resource:image/*'
      },
      {
        value: 'f3',
        label: '動画あり',
        words: 'resource:video/*'
      },
      {
        value: 'f4',
        label: '音声あり',
        words: 'resource:audio/*'
      }
    ]

    // エラーメッセージ
    this.errorMessages = {
      0: undefined,
      2: 'タイトルに空白が入っています',
      // https://dev.evernote.com/doc/reference/Errors.html
      // 19=> RATE_LIMIT_REACHED
      // Operation denied because the calling application has reached its hourly API call limit for this user.
      19: '`Evernote社が定めている１時間内の利用回数を超えた為、一時的に制限がかかり当サービスから利用ができなくなっています。Evernote社によって制限が解除される ${hour}時以降にアクセスするか、純正アプリをご利用ください。`',
      E01: 'セッションが無効です。ログインし直してください。',
      T01:
        '存在しないノートブックが指定されています。トップ画面へ戻り左上のメニューから「ブック・タグのリロード」を選び、最新にしてから試してください。',
      R00:
        'ブラウザ上の状態が原因で読み込みに失敗しました。再読み込みしてやり直してみてください。',
      R01: 'Evernoteでリソースが見つかりませんでした。',
      R02: '認証情報の復元に失敗しました。',
      S01:
        'この端末よりも新しいノートが Evernoteに存在した為に更新できませんでした。再読み込みして最新の状態にしてからもう一度試してみてください。（再読み込みは画面一番下にある「キャッシュ利用」もしくは「最新」をタップすると表示されるダイアログで行えます）',
      default: 'エラーが発生しました'
    }
  }

  // Messages
  getErrorMessage(results) {
    const message = this.errorMessages[results.errorCode] || results.message
    switch (results.errorCode) {
      case 19: {
        // eslint-disable-next-line no-unused-vars
        const hour = new Date().getHours() + 1
        return eval(message)
      }
      default:
        return message
    }
  }
  getErrorCode(results) {
    return 'EN-' + ('000' + (results.errorCode || '0')).slice(-3)
  }

  getReminderCondition(rc) {
    return this.reminderConditions.find(c => c.value == rc)
  }

  getFileCondition(fl) {
    return this.fileConditions.find(c => c.value == fl)
  }

  getDateCondition(dc) {
    let result = this.dateConditions.find(d => d.value == dc)
    if (!result) {
      result = this.getYearMonthConditions().find(d => d.value == dc)
    }
    if (!result) {
      result = this.getYearConditions().find(d => d.value == dc)
    }
    return result
  }

  // Event
  addListener(name, callback) {
    const listners = this.events[name] || []
    listners.push(callback)
    this.events[name] = listners
  }

  emit(name, value) {
    const listners = this.events[name] || []
    listners.forEach(listener => {
      listener(value)
    })
  }

  // get sessionId() {
  //   return window.$cookies.get(SESSION_ID_KEY)
  // }

  // set sessionId(id) {
  //   window.$cookies.set(SESSION_ID_KEY, id, 60 * 60 * 24 * 30) // 30d
  //   // window.$cookies.set(SESSION_ID_KEY, id, '30d')
  // }

  // set temporaryToken(token) {
  //   // secure=false 開発環境ではhttpになるため
  //   // window.$cookies.set(TEMPORAY_TOKEN_KEY, token, 0, '/', null, null, 'Strict')
  //   window.document.cookie = `${TEMPORAY_TOKEN_KEY}=${token}; SameSite=Strict`
  // }

  // get temporaryToken() {
  //   console.log('temporayToken is called')
  //   let value = undefined
  //   console.log('window.document.cookie', window.document.cookie)
  //   window.document.cookie.split(';').forEach(cookie => {
  //     const index = cookie.indexOf('=')
  //     if (index) {
  //       const key = cookie.substring(0, index).trim()
  //       if (key == TEMPORAY_TOKEN_KEY) {
  //         value = cookie.substring(index + 1)
  //       }
  //     }
  //   })
  //   return value
  //   // return window.$cookies.get(TEMPORAY_TOKEN_KEY)
  // }
  setTemporaryToken(token) {
    lsService.save(TEMPORAY_TOKEN_KEY, token)
  }
  getTemporaryToken() {
    return lsService.restore(TEMPORAY_TOKEN_KEY, '')
  }
  removeTemporaryToken() {
    lsService.remove(TEMPORAY_TOKEN_KEY)
    // window.$cookies.remove(TEMPORAY_TOKEN_KEY)
    // window.document.cookie = `${TEMPORAY_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`
  }

  // get isLoggedIn() {
  //   // return this.sessionId != undefined
  //   return true
  //   /*
  //   =============ここを書き直す=====
  //   */
  // }

  async setup() {
    // indexedDB はキーバリューの為、ソート済みデータを入れてもバラバラの順序で出てくる
    if (this._notebooks === undefined) {
      // タイミングによって indexedDBの初期化が遅れ,notebooks == undefinedとなってしまう。
      // 回避の為にApp側で２回呼ぶようにする
      if (indexedDB.notebooks) {
        this._notebooks = (await indexedDB.notebooks.get()).sort((a, b) =>
          a.name < b.name ? -1 : 1
        )
        this.emit('NOTEBOOK_LOADED')
      }
    }
    if (this._tags === undefined) {
      if (indexedDB.tags) {
        this._tags = (await indexedDB.tags.get()).sort((a, b) =>
          a.name < b.name ? -1 : 1
        )
        this.emit('TAG_LOADED')
      }
    }
  }

  //------------------------------------
  // State & Status
  //------------------------------------
  get loggedInBefore() {
    return lsService.getBoolean(LOGGED_IN_BEFORE_KEY)
  }
  set loggedInBefore(v) {
    lsService.setBoolean(LOGGED_IN_BEFORE_KEY, v)
  }

  //------------------------------------
  // date
  //------------------------------------
  getYearConditions() {
    if (this.yearConditions && this.yearConditions.length > 0) {
      return this.yearConditions
    }
    const now = new Date()
    for (let year = now.getFullYear(); 2008 <= year; year--) {
      this.yearConditions.push({
        value: `D${year}`,
        label: `${year}年`,
        words: `created:${year}0101 -created:${year + 1}0101`
      })
    }
    return this.yearConditions
  }

  getYearMonthConditions() {
    if (this.yearMonthConditions && this.yearMonthConditions.length > 0) {
      return this.yearMonthConditions
    }

    const now = new Date()
    let startMonth = now.getMonth()
    for (let year = now.getFullYear(); 2008 <= year; year--) {
      for (let month = startMonth ? startMonth : 12; month > 0; month--) {
        const m = ('0' + month).slice(-2)
        const nextYear = month == 12 ? year + 1 : year
        const nextMonth = month == 12 ? 1 : month + 1
        const n_m = ('0' + nextMonth).slice(-2)
        this.yearMonthConditions.push({
          value: `D${year}${m}`,
          label: `${year}年${m}月`,
          words: `created:${year}${m}01 -created:${nextYear}${n_m}01`
        })
        startMonth = 0
      }
    }
    return this.yearMonthConditions
  }

  //------------------------------------
  // token
  //------------------------------------
  async getToken() {
    if (this._token) {
      // console.log('@use token cache')
      return this._token
    } else {
      // console.log('@getting token ...')
      const result = await this.callPostWithCredentials('token', {
        // sessionId: this.sessionId  // to_be_removed
      })
      if (result.succeeded) {
        this._token = result.token
        return this._token
      } else {
        console.log('getToken() failed', result)
        return undefined
      }
    }
  }

  //------------------------------------
  // Notebooks
  //------------------------------------
  get notebooks() {
    if (this._notebooks) {
      return this._notebooks
    }
    return []
  }
  set notebooks(list) {
    this._notebooks = list
    indexedDB.notebooks.clear().then(() => {
      indexedDB.notebooks.put(list).then(notebooks => {
        console.log('[INFO] Saved notebooks: ', notebooks.length)
      })
    })
  }

  // Item {
  //    modified: Date.getTime()
  //    list: [ {guid:, name:}, ...]
  // }
  get recentNotebooks() {
    const recentNotebooks = []
    if (this.notebooks) {
      lsService.restore(EG_RECENT_NOTEBOOK_GUIDS_KEY, []).forEach(guid => {
        const notebook = this.notebooks.find(notebook => notebook.guid == guid)
        if (notebook) {
          recentNotebooks.push(notebook)
        }
      })
    }
    return recentNotebooks
  }

  pushRecentNotebookGuid(guid) {
    let guids = lsService
      .restore(EG_RECENT_NOTEBOOK_GUIDS_KEY, [])
      .filter(g => g != guid)
    guids.unshift(guid)
    lsService.save(
      EG_RECENT_NOTEBOOK_GUIDS_KEY,
      guids.slice(0, EG_RECENT_NOTEBOOKS_MAX)
    )
  }
  pushRecentNotebook(notebook) {
    this.pushRecentNotebookGuid(notebook.guid)
  }

  clearRecentNotebooks() {
    lsService.remove(EG_RECENT_NOTEBOOK_GUIDS_KEY)
  }

  get selectedNotebook() {
    if (this.notebooks) {
      const guid = this.selectedNotebookGuid
      if (guid) {
        return this.notebooks.find(notebook => notebook.guid == guid)
      } else if (this.notebooks.length > 0) {
        return this.notebooks[0]
        // TODO: inboxのguidを入手しておき利用する
      }
    }
    return undefined
  }

  set selectedNotebook(notebook) {
    if (notebook && notebook.guid) {
      lsService.set(EG_SELECTED_NOTEBOOK_GUID_KEY, notebook.guid)
    }
  }

  get selectedNotebookGuid() {
    return lsService.get(EG_SELECTED_NOTEBOOK_GUID_KEY)
  }

  set defaultNotebookGuid(guid) {
    if (guid) {
      lsService.set(EG_DEFAULT_NOTEBOOK_GUID_KEY, guid)
    }
  }
  get defaultNotebookGuid() {
    return lsService.get(EG_DEFAULT_NOTEBOOK_GUID_KEY)
  }

  get defaultNotebook() {
    // console.log(this.getNotebook(this.defaultNotebookGuid))
    return this.getNotebook(this.defaultNotebookGuid)
  }

  clearDefaultNotebook() {
    lsService.remove(EG_DEFAULT_NOTEBOOK_GUID_KEY)
  }

  getNotebook(guid) {
    const notebook = this.notebooks.find(n => n.guid == guid)
    if (notebook) {
      return notebook
    }
    if (guid == this.randomNotebook.guid) {
      return this.randomNotebook
    }
  }

  getNotebookName(guid) {
    if (guid) {
      const notebook = this.getNotebook(guid)
      if (notebook) {
        return notebook.name
      }
    }
    // return '（不明なノートブック）'
    return ''
  }

  getSortedNotebooks(ascending) {
    const vector = ascending ? -1 : 1
    return this.notebooks.sort((a, b) => (a.name < b.name ? vector : -vector))
  }

  get randomNotebook() {
    return {
      guid: 'sp1',
      name: 'ランダム',
      icon: 'mdi-apps'
    }
  }

  getNotebookWithRandom() {
    const index = Math.floor(Math.random() * this.notebooks.length)
    return this.notebooks[index]
  }

  //-------------
  // Tags
  //-------------
  get tags() {
    if (this._tags) {
      return this._tags
    }
    return []
  }
  set tags(list) {
    this._tags = list
    indexedDB.tags.clear().then(() => {
      indexedDB.tags.put(list).then(tags => {
        console.log('[INFO] Saved tags: ', tags.length)
      })
    })
  }

  // Item {
  //    modified: Date.getTime()
  //    list: [ {guid:, name:}, ...]
  // }
  get recentTags() {
    const recentTags = []
    if (this.tags) {
      lsService.restore(EG_RECENT_TAG_GUIDS_KEY, []).forEach(guid => {
        const tag = this.tags.find(tag => tag.guid == guid)
        if (tag) {
          recentTags.push(tag)
        }
      })
    }
    return recentTags
  }

  pushRecentTagGuids(selectedGuids) {
    const guids = lsService
      .restore(EG_RECENT_TAG_GUIDS_KEY, [])
      .filter(guid => !selectedGuids.includes(guid))
    guids.unshift(...selectedGuids)
    lsService.save(EG_RECENT_TAG_GUIDS_KEY, guids.slice(0, EG_RECENT_TAGS_MAX))
  }

  pushRecentTags(tags) {
    this.pushRecentTagGuids(tags.map(tag => tag.guid))
  }

  clearRecentTags() {
    lsService.remove(EG_RECENT_TAG_GUIDS_KEY)
  }

  get selectedTags() {
    const selectedTags = []
    if (this.tags) {
      const v = lsService.get(EG_SELECTED_TAG_GUIDS_KEY)
      if (v) {
        try {
          const guids = JSON.parse(v)
          guids.forEach(guid => {
            const tag = this.tags.find(tag => tag.guid == guid)
            if (tag) {
              selectedTags.push(tag)
            }
          })
        } catch (e) {
          console.log(e)
        }
      }
    }
    return selectedTags
  }

  set selectedTags(tags) {
    if (tags) {
      const guids = tags.map(tag => tag.guid)
      lsService.set(EG_SELECTED_TAG_GUIDS_KEY, JSON.stringify(guids))
    }
  }

  get selectedTagIndexes() {
    const indexes = []
    const tags = this.tags
    if (tags && this.selectedTags.length > 0) {
      this.selectedTags.forEach(selectedTag => {
        const index = tags.findIndex(tag => tag.guid == selectedTag.guid)
        if (index >= 0) {
          indexes.push(index)
        }
      })
    }
    return indexes
  }

  getSortedTags(ascending) {
    const vector = ascending ? -1 : 1
    return this.tags.sort((a, b) => (a.name < b.name ? vector : -vector))
  }

  //==
  initInfo() {
    this.callPostWithCredentials('user').then(data => {
      this.user = data.user
    })
  }
  clearInfo() {
    lsService.remove(EG_USER_KEY)
  }
  get user() {
    return lsService.restore(EG_USER_KEY)
  }
  set user(user) {
    lsService.save(EG_USER_KEY, user)
  }

  //==
  getTagNames(guids) {
    if (guids) {
      return guids.map(g => {
        const tag = this.tags.find(t => t.guid == g)
        if (tag) {
          return tag
        }
        if (g == this.randomTag.guid) {
          return this.randomTag
        }
        return { name: ' ', guid: undefined }
        // return { name: '（不明なタグ）', guid: undefined }
      })
    } else {
      return []
    }
  }

  get randomTag() {
    return {
      guid: 'sp1',
      name: 'ランダム',
      icon: 'mdi-apps'
    }
  }

  getTagWithRandom() {
    const index = Math.floor(Math.random() * this.tags.length)
    return this.tags[index]
  }

  // Utilities
  getApiUrl(path) {
    const url = API_URLS[this.api_env] || API_URLS['prod']
    return `${url}/${path}`
  }

  async logout(deleteCache) {
    await this.call('get', 'logout', null, null, true)
    if (deleteCache) {
      this.clearRecentNotebooks()
      this.clearRecentTags()
      this.clearInfo()
      this.clearDefaultNotebook()
      noteHistoryService.clear()
      await indexedDB.deleteDB()
      console.log('[INFO] All stores are deleted.')
    }
    this.loggedInBefore = false
  }

  //-------------------
  // Universal Call
  //------------------
  async call(method, path, params = {}, headers = {}, withCredentials) {
    this.increaseAPICounter()

    const config = {
      method: method,
      url: this.getApiUrl(path),
      data: {
        service: SERVICE,
        // sessionId: this.sessionId,   // to_be_removed
        ...params
      },
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY,
        ...(headers || {})
      }
    }
    if (withCredentials) {
      config['withCredentials'] = true
    }
    let response = await axios(config).catch(error => {
      if (error && error.response && error.response.status == 401) {
        this.isLoggedIn = false
        return error.response
      }
    })
    if (response) {
      response.data.errorMessage = this.getErrorMessage(response.data)
      response.data.errorCode = this.getErrorCode(response.data)
    } else {
      response = {
        data: {
          failed: true,
          succeeded: false,
          errorMessage: 'ネットワークが利用できません',
          message: 'ネットワークが利用できません',
          errorCode: 'EN-901'
        }
      }
    }
    return response.data
  }

  //----------------
  // methods
  //----------------
  async callPostWithCredentials(path, params, headers) {
    return this.call('post', path, params, headers, true)
  }

  async callPut(path, params, headers) {
    return this.call('put', path, params, headers, true)
  }

  async callDelete(path, params, headers) {
    return this.call('delete', path, params, headers, true)
  }

  // async callGet(path) {
  //   return this.call('get', path, {}, {})
  // }

  // 2019-12-15 sessionIdはBackendで処理されない（req.body.sessionIdをとるため→Postを使うこと）
  // 2020-01-04 ↑改善：{ params: パラメータ}で渡せた -> またエラー？
  async callGetWithCredentials(path, params, headers) {
    this.increaseAPICounter()

    const response = await axios.get(this.getApiUrl(path), {
      params: {
        service: SERVICE,
        // sessionId: this.sessionId, // to_be_removed
        ...params
      },
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY,
        ...(headers || {})
      },
      withCredentials: true
    })
    response.data.errorMessage = this.getErrorMessage(response.data)
    response.data.errorCode = this.getErrorCode(response.data)
    return response.data
  }

  // call evernote-backend
  async postFile(text, attrs, files) {
    this.increaseAPICounter()

    const data = new FormData()
    data.append('body', text)
    files.forEach(file => {
      data.append('files', file)
    })
    data.append('service', SERVICE)
    // data.append('sessionId', this.sessionId) // to_be_removed
    let notebook = this.selectedNotebook
    if (notebook) {
      // 何らかの理由で取れない（ローカル情報が削除されたなど）
      data.append('notebookGuid', notebook.guid)
    }
    this.selectedTags.forEach(tag => {
      data.append('tagGuids', tag.guid)
    })
    if (attrs.coords) {
      data.append('latitude', attrs.coords.latitude)
      data.append('longitude', attrs.coords.longitude)
    }
    if (attrs.reminderTime) {
      data.append('reminderTime', attrs.reminderTime.getTime())
    }

    const response = await axios.post(this.getApiUrl('post'), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-api-key': API_KEY
      }
    })
    response.data.errorMessage = this.getErrorMessage(response.data)
    response.data.errorCode = this.getErrorCode(response.data)
    return response.data
  }

  // post(text, attrs) {
  //   const options = {}
  //   const tags = this.selectedTags
  //   if (tags) {
  //     options.tagGuids = tags.map(tag => tag.guid)
  //   }
  //   if (attrs.coords) {
  //     options.latitude = attrs.coords.latitude
  //     options.longitude = attrs.coords.longitude
  //   }
  //   if (attrs.reminderTime) {
  //     options.reminderTime = attrs.reminderTime.getTime()
  //   }

  //   return this.callPostWithCredentials('post', {
  //     body: text,
  //     notebookGuid: this.selectedNotebook.guid,
  //     ...options
  //   })
  // }

  notes(options) {
    return this.callPostWithCredentials('notes', options)
  }

  note(guid) {
    return this.callPostWithCredentials('note', { guid: guid })
  }

  async relatedNotes(guid, prepareFunction) {
    const notes = await this.getRelatedNotesFromCache(guid)
    if (notes) {
      console.log('+ use cache (related notes)')
      return notes
      // return notes.sort((a, b) => (a.created > b.created ? -1 : 1))
    }
    prepareFunction()
    const data = await this.callPostWithCredentials('relatedNotes', {
      guid: guid,
      maxNotes: MAX_RELATED_NOTES
    })
    if (data && data.result && data.result.notes) {
      console.log('- reload (related notes)')
      const notes = data.result.notes
      await this.putRelatedNotesToCache(guid, notes)
      return notes
      // return notes.sort((a, b) => (a.created > b.created ? -1 : 1))
    }
    return []
  }

  oauth(callbackUrl) {
    return this.callPostWithCredentials('oauth', { callbackUrl: callbackUrl })
  }

  callback(oauthToken, oauthVerifier, temporaryToken) {
    return this.callPostWithCredentials('callback', {
      oauthToken: oauthToken,
      oauthVerifier: oauthVerifier,
      temporaryToken: temporaryToken
    })
  }

  reloadNotebooks() {
    return this.callPostWithCredentials('notebooks', {}).then(data => {
      if (data.notebooks) {
        this.notebooks = data.notebooks
          .map(n => ({
            guid: n.guid,
            name: n.name
          }))
          .sort((a, b) => (a.name < b.name ? -1 : 1))
      }
      return data
    })
  }

  reloadTags() {
    return this.callPostWithCredentials('tags', {}).then(data => {
      if (data.tags) {
        this.tags = data.tags
          .map(n => ({
            guid: n.guid,
            name: n.name
          }))
          .sort((a, b) => (a.name < b.name ? -1 : 1))
      }
      return data
    })
  }

  fetchDefaultNotebook() {
    return this.callPostWithCredentials('defaultNotebook', {}).then(data => {
      if (data.notebook && data.notebook.guid) {
        this.defaultNotebookGuid = data.notebook.guid
      }
      return data
    })
  }

  reloadNotebooksAndTags() {
    return Promise.all([
      this.reloadNotebooks(),
      this.reloadTags(),
      this.fetchDefaultNotebook()
    ])
  }

  getInfo() {
    return this.callGetWithCredentials('info')
  }

  // getResource(params) {
  //   return this.callGetWithCredentials('resource', params)
  // }

  //-----------------------------
  // Update
  //-----------------------------
  updateNote(note) {
    return this.callPut('note', {
      note: JSON.stringify(note)
    }).then(results => {
      if (!results.updated) {
        console.log(
          `updateSequenceNum not macth: local=${note.updateSequenceNum} / remote=${results.updateSequenceNum}`
        )
        results.failed = true
        results.errorCode = 'S01'
        results.errorMessage = this.getErrorMessage(results)
        results.errorCode = this.getErrorCode(results)
      }
      return {
        failed: results.failed,
        message: results.errorMessage,
        code: results.errorCode, // EN-000 エバーノート系のエラー,
        data: {
          updated: results.updated, // true=更新された/false=されず
          updateSequenceNum: results.updateSequenceNum // USN
        }
      }
    })
  }

  //-----------------------------
  // Delete
  //-----------------------------
  deleteNote(guid) {
    return this.callDelete('note', {
      guid: guid
    })
  }

  //-----------------------------
  // Resource
  //-----------------------------
  // async hasResourceCache(guid) {
  //   let resource = await store.get(guid)
  //   return resource != undefined
  // }

  async _loadResource(noteGuid, resourceGuid, prefix, store, cacheOnly) {
    let resource = await store.get(resourceGuid)
    if (resource) {
      // console.log('+ use cache (resource)')
      const blob = resource.data
      if (noteGuid) {
        if (
          resource.data &&
          resource.data.type &&
          resource.data.type.match(/^image\/(png|jpeg|gif|webp)/)
        ) {
          // console.log('[1] get cover thumbnail')
          // console.log(resource.data)
          noteMeta.putNoteRepresentedResourceGuid(
            noteGuid,
            resourceGuid,
            resource.data.size
          )
        }
      }
      return { cache: true, url: URL.createObjectURL(blob) }
    } else if (!cacheOnly) {
      let p = prefix || this.getResourcePrefix()
      const url = `https://${API_GATEWAY_HOST}/shard/${p}/res/${resourceGuid}`
      // 'https://a2xfkt1lk7.execute-api.ap-northeast-1.amazonaws.com/shard/s12/res/a82ec1bc-2ff5-444f-a66d-8d412dc928ec'
      // 'https://a2xfkt1lk7.execute-api.ap-northeast-1.amazonaws.com/shard/s12/res/8be0e575-1567-4460-9c6a-c3bbd02fcdf7'
      const params = new URLSearchParams()
      const token = await this.getToken()
      if (token) {
        // console.log('token', token)
        params.append('auth', token)
        const config = { responseType: 'arraybuffer' }
        let response = await axios.post(url, params, config).catch(error => {
          console.log(error)
        })
        if (response && response.data) {
          this.increaseAPIResourceCounter()
          const contentType = response.headers['content-type']
          const blob = new Blob([response.data], {
            type: contentType
          })
          let url = URL.createObjectURL(blob)

          store
            .put({ guid: resourceGuid, data: blob, contentType: contentType })
            .then(() => {})

          if (contentType.match(/^image\/(png|jpeg|gif|webp)/)) {
            // console.log('[2] get cover thumbnail')
            // console.log(response.data)
            noteMeta.putNoteRepresentedResourceGuid(
              noteGuid,
              resourceGuid,
              response.data.byteLength
            )
          }

          return {
            cache: false,
            url: url
          }
        } else {
          return {
            failed: true,
            errorMessage: this.errorMessages['R01'],
            errorCode: 'R01'
          }
        }
      } else {
        // failed to get token
        return {
          failed: true,
          errorMessage: this.errorMessages['R02'],
          errorCode: 'R02'
        }
      }
    }
    return undefined
  }

  async loadResource(noteGuid, resourceGuid, prefix, cacheOnly) {
    return this._loadResource(
      noteGuid,
      resourceGuid,
      prefix,
      indexedDB.resources,
      cacheOnly
    )
  }
  async loadResourceFromCache(resourceGuid) {
    return this._loadResource(
      undefined,
      resourceGuid,
      undefined,
      indexedDB.resources,
      true
    )
  }
  async loadResourceThumbnail(noteGuid, resourceGuid, cacheOnly) {
    return this._loadResource(
      noteGuid,
      resourceGuid,
      this.user.shardId + '/thm',
      indexedDB.thumbnails,
      cacheOnly
    )
  }
  async loadResourceThumbnailFromCache(resourceGuid) {
    return this._loadResource(
      undefined,
      resourceGuid,
      undefined,
      indexedDB.thumbnails,
      true
    )
  }

  getResourceHashString(resource) {
    if (resource) {
      return resource.data.bodyHash.data
        .map(b => ('0' + b.toString(16)).slice(-2))
        .join('')
    } else {
      return undefined
    }
  }

  getResourceByHash(note, hash) {
    return note.resources.find(
      resource => this.getResourceHashString(resource) === hash
    )
  }

  getResources(note) {
    const keys = {}
    if (note.resources) {
      note.resources.forEach(resource => {
        const hash = this.getResourceHashString(resource)
        // console.log(resource)
        if (hash) {
          keys[hash] = {
            prefix: this.getResourcePrefix(),
            noteGuid: note.guid,
            ...resource
            // guid: resource.guid,
            // mime: resource.mime
          }
          // keys[hash] = this.encodeResourceParameters({
          //   prefix: this.getResourcePrefix(),
          //   guid: resource.guid,
          //   mime: resource.mime,
          //   noteGuid: note.guid,
          //   fileName: resource.attributes.fileName
          // })
        }
      })
    }
    return keys
  }

  getResourceHashes(note) {
    // イベントがハンドルできない場合は正規表現を見直す
    const regex = /<en-media.+?hash="([^"]+)"[^>]+>/g
    let result
    const resourceHashes = []
    while ((result = regex.exec(note.content))) {
      resourceHashes.push(result[1])
    }
    return resourceHashes
  }

  // e.g.: 's12'
  getResourcePrefix() {
    return this.user.webApiUrlPrefix.replace(/.+\/shard\/(.+)\//, '$1')
  }

  getResourceURL(guid, prefix) {
    let p = prefix || this.getResourcePrefix()
    if (guid) {
      return `https://www.evernote.com/shard/${p}/res/${guid}`
    } else {
      return undefined
    }
    // return `${this.user.webApiUrlPrefix}res/`
  }

  // {key:value,..} => base64
  encodeResourceParameters(params) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(params))))
  }
  decodeResourceParameters(value) {
    let result = {}
    const str = decodeURIComponent(escape(atob(value)))
    if (str) {
      try {
        result = JSON.parse(str)
      } catch (error) {
        console.log(error)
      }
    }
    return result
  }

  //-----------------------------
  // Related notes cache
  //-----------------------------
  async putRelatedNotesToCache(noteGuid, releatedNotes) {
    const data = { guid: noteGuid, notes: releatedNotes }
    indexedDB.relatednotes.put(data)
  }
  async getRelatedNotesFromCache(noteGuid) {
    const data = await indexedDB.relatednotes.get(noteGuid)
    if (data && data.notes) {
      return data.notes
    }
    return undefined
  }
  async removeRelatedNotesFromCache(noteGuid) {
    await indexedDB.relatednotes.delete(noteGuid)
  }

  //-----------------------------
  // Utilities
  //-----------------------------
  getNoteURL(guid) {
    // https://qiita.com/s-yoshiki/items/9cab4e73dd677442469a
    if (
      (navigator.userAgent.indexOf('iPhone') > 0 &&
        navigator.userAgent.indexOf('iPad') == -1) ||
      navigator.userAgent.indexOf('iPod') > 0 ||
      navigator.userAgent.indexOf('Android') > 0
    ) {
      // mobile
      return `evernote:///view/${this.user.id}/${this.user.shardId}/${guid}/${guid}/`
    } else {
      // pc
      return `https://www.evernote.com//Home.action#n=${guid}&s=s12&ses=4&sh=2&sds=5`
      // return `https://www.evernote.com/client/web#?fs=true&n=${guid}`  古い
    }
  }

  getReminderColorWithTime(reminderTime, reminderDoneTime) {
    if (reminderDoneTime) {
      return 'green'
    } else if (reminderTime > new Date().getTime()) {
      return 'blue'
    } else if (!reminderTime) {
      return 'purple'
    } else {
      return 'red'
    }
  }

  getReminderColorWithNote(note) {
    if (note.attributes && note.attributes.reminderOrder) {
      return this.getReminderColorWithTime(
        note.attributes.reminderTime,
        note.attributes.reminderDoneTime
      )
    }
    return ''
  }
  getAltReminderTime(note) {
    if (note.attributes && note.attributes.reminderOrder) {
      if (note.attributes.reminderDoneTime) {
        return note.attributes.reminderDoneTime
      } else if (note.attributes.reminderTime) {
        return note.attributes.reminderTime
      }
    }
    return undefined
  }

  get emptyNote() {
    return {
      guid: undefined
    }
  }

  // https://www.ipentec.com/document/google-map-link
  getMapURL(note) {
    return `https://www.google.co.jp/maps/@${note.attributes.latitude},${note.attributes.longitude},15z`
  }
  hasLocation(note) {
    return note && note.attributes && note.attributes.latitude
  }

  getQueryTitle(query) {
    if (query.words) {
      return query.words
    }
    if (query.nb) {
      return this.getNotebookName(query.nb)
    }
    if (query.tg && query.tg.length > 0) {
      return this.getTagNames(query.tg)[0].name
    }
    if (query.dc) {
      return this.getDateCondition(query.dc).label
    }
    if (query.rc) {
      return this.getReminderCondition(query.rc).label
    }
    return ''
  }

  //-------------------
  // API counter
  // {
  //    key: 202003081900,
  //    count: 0
  // }
  //-------------------
  getAPILimitCount() {
    return EVERNOTE_API_LIMIT_COUNT
  }
  getAPICounter() {
    const key = dateService.getYYYYMMDDHH()
    const counter = lsService.restore(EG_API_COUNTER_KEY)
    if (counter.key == key) {
      return counter
    }
    return { key: key, count: 0, resource_count: 0 }
  }
  saveAPICounter(counter) {
    lsService.save(EG_API_COUNTER_KEY, counter)
    // console.log(`API Count ${counter.count}:${counter.resource_count}`)
  }
  getAPICount() {
    return this.getAPICounter().count
  }
  getAPIResourceCount() {
    return this.getAPICounter().resource_count
  }
  getAPIRestCount() {
    return EVERNOTE_API_LIMIT_COUNT - this.getAPICount()
  }
  getAPIResourceRestCount() {
    return EVERNOTE_API_LIMIT_COUNT - this.getAPIResourceCount()
  }
  increaseAPICounter() {
    const counter = this.getAPICounter()
    counter.count = counter.count + 1
    this.saveAPICounter(counter)
  }
  increaseAPIResourceCounter() {
    const counter = this.getAPICounter()
    counter.resource_count = counter.resource_count + 1
    this.saveAPICounter(counter)
  }
  getStyleAPI(n) {
    if (n >= 100) {
      return 'color:#00a000;'
    } else if (n > 0) {
      return 'color:#c0a000;'
    }
    return 'color:#ff0000;font-weight:bold'
  }
  getStyleOfAPICount() {
    return this.getStyleAPI(this.getAPIRestCount())
  }
  getStyleOfAPIResourceCount() {
    return this.getStyleAPI(this.getAPIResourceRestCount())
  }

  //-------------------
  // Test
  // //-------------------
  // async test() {
  //   const res = await this.callGetWithCredentials('test')
  //   console.log(res)
  // }
}

const evernoteService = new EvernoteService()
export default evernoteService
